import type { GameContent } from "../../engine/types";
import { AMPHIBIAN_EVENTS } from "./amphibian";
import { ARACHNID_MYRIAPOD_EVENTS } from "./arachnid-myriapod";
import { BIOME_EVENTS } from "./biomes";
import { BIRD_EVENTS } from "./bird";
import { BIRD_SUBGROUP_EVENTS } from "./bird-subgroups";
import { COMMON_EVENTS } from "./common";
import { ENCOUNTER_EVENTS } from "./encounters";
import { CRUSTACEAN_MOLLUSC_EVENTS } from "./crustacean-mollusc";
import { FAMILY_EVENTS } from "./family";
import { FISH_EVENTS } from "./fish";
import { FISH_INSECT_SUBGROUP_EVENTS } from "./fish-insect-subgroups";
import { INSECT_EVENTS } from "./insect";
import { MAMMAL_EVENTS } from "./mammal";
import { MAMMAL_SUBGROUP_EVENTS } from "./mammal-subgroups";
import { MARINE_INVERTEBRATE_EVENTS } from "./marine-invertebrates";
import { MIGRATION_EVENTS } from "./migration";
import { REGION_EVENTS } from "./regions";
import { REPTILE_EVENTS } from "./reptile";
import { REPTILE_AMPHIBIAN_SUBGROUP_EVENTS } from "./reptile-amphibian-subgroups";
import { SIGNATURE_BIRD_EVENTS } from "./signature-birds";
import { SIGNATURE_INVERTEBRATE_EVENTS } from "./signature-invertebrates";
import { SIGNATURE_MAMMAL_EVENTS } from "./signature-mammals";
import { SIGNATURE_REPTILE_FISH_EVENTS } from "./signature-reptiles-fish";
import { SOCIAL_INSECT_EVENTS } from "./social-insect";
import { WORM_EVENTS } from "./worm";

export const CONTENT: GameContent = {
  events: [
    ...COMMON_EVENTS,
    ...MAMMAL_EVENTS,
    ...BIRD_EVENTS,
    ...REPTILE_EVENTS,
    ...AMPHIBIAN_EVENTS,
    ...FISH_EVENTS,
    ...INSECT_EVENTS,
    // เนื้อเรื่องเฉพาะกลุ่มย่อย
    ...MAMMAL_SUBGROUP_EVENTS,
    ...BIRD_SUBGROUP_EVENTS,
    ...REPTILE_AMPHIBIAN_SUBGROUP_EVENTS,
    ...FISH_INSECT_SUBGROUP_EVENTS,
    // เฟส 3: สัตว์ไม่มีกระดูกสันหลัง
    ...SOCIAL_INSECT_EVENTS,
    ...ARACHNID_MYRIAPOD_EVENTS,
    ...CRUSTACEAN_MOLLUSC_EVENTS,
    ...WORM_EVENTS,
    ...MARINE_INVERTEBRATE_EVENTS,
    // ตามประเภทพื้นที่ตรงที่เราอยู่ (ต้องมีตำแหน่งบนแผนที่)
    ...BIOME_EVENTS,
    ...REGION_EVENTS,
    ...MIGRATION_EVENTS,
    ...FAMILY_EVENTS,
    // เหตุการณ์เฉพาะตัวของสัตว์ดัง
    ...SIGNATURE_MAMMAL_EVENTS,
    ...SIGNATURE_BIRD_EVENTS,
    ...SIGNATURE_REPTILE_FISH_EVENTS,
    ...SIGNATURE_INVERTEBRATE_EVENTS,
    // เจอนักล่าหรือเหยื่อที่เป็นชนิดจริงแถวนี้ (ต้องมีตำแหน่งบนแผนที่)
    ...ENCOUNTER_EVENTS,
  ],
};
